export default "__VITE_ASSET__56b3d700__"